import {Textarea as ChakraTextarea, Field, TextareaProps} from '@chakra-ui/react'
import {ReactNode} from 'react'
import {ErrorMessage} from '../../components/form/error-message.js'
import {FieldRequiredIndicator} from '../../components/form/field-required-indicator.js'
import {FieldRoot} from '../../components/form/field-root.js'
import {useFieldContext} from '../../integrations/form/index.js'

interface Props extends TextareaProps {
  label: ReactNode
  hideLabel?: boolean
  helpText?: string
}

export function Textarea({label, hideLabel, required, ...props}: Props) {
  const field = useFieldContext<string>()

  return (
    <FieldRoot required={required} disabled={props.disabled}>
      <Field.Label srOnly={hideLabel}>
        {label}
        {required && <FieldRequiredIndicator />}
      </Field.Label>

      <ChakraTextarea
        backgroundColor="bg"
        name={field.name}
        placeholder={props.placeholder}
        value={field.state.value}
        onChange={e => field.handleChange(e.target.value)}
        onBlur={() => field.handleBlur()}
        {...props}
      />

      {props.helpText && <Field.HelperText>{props.helpText}</Field.HelperText>}
      <ErrorMessage />
    </FieldRoot>
  )
}
